import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { VexPageLayoutComponent } from 'src/@vex/components/vex-page-layout/vex-page-layout.component';
import { VexPageLayoutContentDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-content.directive';
import { VexSecondaryToolbarComponent } from 'src/@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
import { VexPageLayoutHeaderDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-header.directive';
import { CompeleteOrderComponent } from './compelete-order/compelete-order.component';
import { DriverTripsComponent } from './driver-trips.component';
import { DriverTripsRoutingModule } from './driver-trips-routing.module';


@NgModule({
  declarations: [DriverTripsComponent,CompeleteOrderComponent],
  imports: [
    CommonModule,
    DriverTripsRoutingModule,
    SharedModule,
  ]
})
export class DriverTripsModule { }
